import { Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '@socrates/common';

// NOTE! IMPORTANT! This does a contains search.  NOT an exact match filter.
@Pipe({
	name: 'filter',
	standalone: false,
})
export class FilterPipe implements PipeTransform {

	transform(list: any, args): any {

		let result: any = list;

		// this is only meant to search strings.  Use PropTestPipe for other types.
		if (args.filter  && Array.isArray(list) && list.length > 0) {
			let filterValue: any = args.filter;
			if (typeof args.filter === 'string') {
				filterValue = filterValue.toLowerCase();
			} else {
				filterValue = '' + args.filter;
			}
			const dashV: boolean = args.reverse;
			const exactMatch: boolean = args.exactMatch;

			result = Utilities.filter(list, filterValue, args.fields, exactMatch, dashV);
		}
		return result;
	}
}
